import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import { NewBackButton } from "../../../components/svgs";
import { DynamicButton, StyledText } from "../../../components/common/basic";

// theme
import { useTheme, useTrivia } from "../../../hooks";
import { OfferAlertModal } from "../../../components/loyalty";
import TriviaRatingModal from "./triviaRating/TriviaRatingModal";

const UserIdentification = () => {
  const [passportNumber, setPaspsortNumber] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [isProcessingRedemption, setProcessingRedemption] = useState(false);

  const { activeTrivia, setUserIdentification } = useTrivia();
  const { themeContext, theme } = useTheme();

  const { hasRedeemed } = (activeTrivia?.userStats?.wonData || {});

  let history = useHistory();

  if (hasRedeemed) history.push(`/trivia/trivia-category`)

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  const themeColor = theme.colors[themeContext.activeTheme]["background"];

  const msg = {
    unplayable: "Sorry, this trivia is only available during the event period.",
    exhaustedAttempts: "You have exhausted your number of tries for this trivia and can no longer play.",
  }

  function isValidPassportNumber(passportNumber) {
    if (typeof passportNumber !== 'string') {
      return false;
    }
    passportNumber = passportNumber.trim();
    const passportRegex = /^[A-Za-z0-9]{6,20}$/;
    return passportRegex.test(passportNumber);
  }

  const submitPassportNumber = (e) => {
    e?.preventDefault();
    setUserIdentification({ passportNumber })
    history.push('/trivia/region')
  }

  return (
    <>
      <MainHolder>
        <Children>
          <div
            style={{
              width: "55%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <BackButtonContainer
              onClick={() => {
                history.push('/trivia/trivia-category');
              }}
              style={{ zIndex: 100, marginLeft: 20 }}
            >
              <NewBackButton />
            </BackButtonContainer>
          </div>
          <DescriptionBody color={mashupBackground}>
            <div style={{ padding: "20px", }}>
              <h2 style={{ fontFamily: "MTNRegular" }}>Passport Verification Required!</h2>
              <p style={{ fontFamily: "MTNRegular", marginBottom: "30px" }}>A valid passport is mandatory for qualification.</p>
              <form onSubmit={submitPassportNumber}>
                <label style={{ fontFamily: "MTNRegular" }}>Enter passport number:</label>
                <input
                  type='text'
                  value={passportNumber}
                  onChange={(e) => { setPaspsortNumber(e.target.value) }}
                  style={{
                    fontFamily: "MTNBold",
                    fontSize: "1.2em",
                    padding: '5px',
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                    color: "#000",
                    width: "100%",
                    border: `1px solid ${themeColor}`,
                    boxSizing: "border-box",
                    background: "none",
                  }}
                />
                <DynamicButton
                  onClick={submitPassportNumber}
                  label={isProcessingRedemption ? "Processing..." : "Submit"}
                  fullWidth
                  disabled={isProcessingRedemption || !isValidPassportNumber(passportNumber)}
                  color={themeColor}
                />
              </form>
              {
                (!isProcessingRedemption && errorMessage) ?
                  <p style={{ fontFamily: "MTNRegular", marginBottom: "30px", color: "red", textAlign: "center" }}>{errorMessage}</p>
                  : <></>
              }
            </div>
          </DescriptionBody>
        </Children>
      </MainHolder>

    </>
  );
};


const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;


export default UserIdentification;
